import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { AdornedInput } from "@zillow/constellation-10";
import { IconSearchFilled } from "@zillow/constellation-icons";
const PLACEHOLDER_TEXT = "Enter your home address";
const rootOverrides = css.raw({
  backgroundColor: "gray.50",
  boxShadowColor: "border.muted",
  _hover: {
    boxShadowColor: "AdornedInput.border.active"
  }
});
const inputOverrides = css.raw({
  _placeholder: {
    color: "text.subtle"
  }
});
const SearchInputWithButton = ({
  _handleAddressSelect,
  _addressSelected,
  _onTagClose,
  _onClear,
  _options,
  ...props
}) => /* @__PURE__ */ jsx(AdornedInput, { css: rootOverrides, input: /* @__PURE__ */ jsx(AdornedInput.Input, { id: void 0, "data-testid": "address-search-input", placeholder: PLACEHOLDER_TEXT, css: inputOverrides, ...props }), endAdornment: /* @__PURE__ */ jsx(AdornedInput.Adornment, { "aria-hidden": "true", children: /* @__PURE__ */ jsx(AdornedInput.Icon, { css: {
  width: "1em",
  height: "1em"
}, children: /* @__PURE__ */ jsx(IconSearchFilled, {}) }) }) });
export {
  PLACEHOLDER_TEXT,
  SearchInputWithButton as default
};
